import { RootState } from 'src/state/reducer';
import { CourseListingState } from 'src/state/courseListing/courseListingReducer';
import { createSelector } from 'reselect';
import { SelectedMap, toSelectedOnlyArray } from 'src/lib/SelectedMap';
import { keys, pipe, reduce } from 'ramda';
import { purge } from 'src/lib/purge';

const countSelectedFilters = (filters: SelectedMap) =>
  pipe(
    keys,
    reduce((acc, key) => (filters[key] ? acc + 1 : acc), 0),
  )(filters);

export const courseListingStateSelector = (state: RootState) => state.courseListing;

export const courseListingSelectedCategoriesSelector = createSelector(
  courseListingStateSelector,
  (state: CourseListingState) => state.selectedCategories,
);

export const courseListingSelectedCategoriesCountSelector = createSelector(
  courseListingSelectedCategoriesSelector,
  (state: SelectedMap) => countSelectedFilters(state),
);

export const courseListingSelectedLevelsSelector = createSelector(
  courseListingStateSelector,
  (state: CourseListingState) => state.selectedLevels,
);

export const courseListingSelectedLevelsCountSelector = createSelector(
  courseListingSelectedLevelsSelector,
  (state: SelectedMap) => countSelectedFilters(state),
);

export const courseListingSelectedSpeakersSelector = createSelector(
  courseListingStateSelector,
  (state: CourseListingState) => state.selectedSpeakers,
);

export const courseListingSelectedSpeakersCountSelector = createSelector(
  courseListingSelectedSpeakersSelector,
  (state: SelectedMap) => countSelectedFilters(state),
);

export const courseListingQueryFiltersSelector = createSelector(
  [
    courseListingSelectedCategoriesSelector,
    courseListingSelectedLevelsSelector,
    courseListingSelectedSpeakersSelector,
  ],
  (categories, levels, speakers) =>
    purge({
      categoryIds: toSelectedOnlyArray(categories),
      levels: toSelectedOnlyArray(levels),
      speakerIds: toSelectedOnlyArray(speakers),
    }),
);

export const courseListingSelectedFiltersCountSelector = createSelector(
  courseListingSelectedCategoriesCountSelector,
  courseListingSelectedLevelsCountSelector,
  courseListingSelectedSpeakersCountSelector,
  (selectedCategoriesCount, selectedLevelsCount, selectedSpeakerCount) =>
    selectedCategoriesCount + selectedLevelsCount + selectedSpeakerCount,
);

export const courseListingPageIndexSelector = createSelector(
  courseListingStateSelector,
  (state) => state.pageIndex,
);

export const courseListingShowAllCategoriesSelector = createSelector(
  courseListingStateSelector,
  (state: CourseListingState) => state.showAllCategories,
);

export const courseListingTotalSelector = createSelector(
  courseListingStateSelector,
  (state: CourseListingState) => state.total,
);

export const courseListingTotalElearningsSelector = createSelector(
  courseListingStateSelector,
  (state: CourseListingState) => state.totalElearningCourses,
);

export const courseListingTotalCourseBundlesSelector = createSelector(
  courseListingStateSelector,
  (state: CourseListingState) => state.totalCourseBundles,
);

export const courseListingTotalResultsSelector = createSelector(
  courseListingStateSelector,
  (state: CourseListingState) =>
    state.total + state.totalElearningCourses + state.totalCourseBundles,
);

export const courseListingViewType = createSelector(
  courseListingStateSelector,
  (state: CourseListingState) => state.courseTypeView,
);
